import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';

import { ProcedureRegisterHistory } from './registerHistory';
import { useProcedurePqrForm } from '../hook';
import { ProcedureParamsData } from './data';
import { ProcedureHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    PROCEDURE_EDIT,
    PROCEDURE_NEW,
    PROCEDURE,
} from '../../../../../routes/paths';

export const ProcedureDetail = () => {
    const [showHistorical, setShowHistorical] = useState(false);

    const { procedure, setformikProcedureData, procedureHistorical } =
        useProcedurePqrForm(showHistorical);

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons = procedure && procedure?.id ? true : false;

    return (
        <>
            <LayoutModule
                title="Detalle Trámite PQR"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={procedure?.id || ''}
                        buttonCreate={{
                            show: showActionButtons && !isOnlyViewProfile(type),
                            route: PROCEDURE_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PROCEDURE,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: PROCEDURE_EDIT,
                        }}
                        buttonView={{
                            show: false,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <ProcedureHistorical
                            historical={procedureHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title="Interno"
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <ProcedureParamsData
                        data={procedure}
                        onChangeFormik={(formik) =>
                            setformikProcedureData(formik)
                        }
                    />
                </LayoutModule>
            </LayoutModule>
            <ProcedureRegisterHistory procedure={procedure} />
        </>
    );
};
